import { createFileRoute, Outlet } from '@tanstack/react-router';

import { AppLayout } from '@/components/layoutAndProvidersWrapper/AppLayout.tsx';

// App layout route group: with padding
// This layout wraps all routes in the (app) group
export const Route = createFileRoute('/(app)')({
  component: () => {
    return (
      <AppLayout>
        <Outlet />
      </AppLayout>
    );
  },
});
